module.exports = __webpack_public_path__ + "fonts/iconfont.48be7b1.ttf";